import styled from 'styled-components';

export const Pests = styled.div`
  background: white;
  min-height: 100%;
`
